const LIST = /<ul\b[^>]*>([\s\S]*?)<\/ul>/i;
const ITEM = /<li\b[^>]*>([\s\S]*?)<\/li>/gi;

export interface UpsellBody {
	intro: string;
	items: string[];
}

/**
 * The banner splices its own product into the authored list with a DS `Tag`, so
 * the list cannot be handed to `RichText` whole. Assumes a flat list; anything
 * authored after it is dropped.
 */
export function splitUpsellBody(body: string | undefined): UpsellBody {
	if (!body) return { intro: "", items: [] };

	const list = LIST.exec(body);
	if (!list) return { intro: body, items: [] };

	return {
		intro: body.slice(0, list.index),
		items: [...list[1].matchAll(ITEM)].map((item) => item[1].trim())
	};
}
